var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Chart Chart--area"},[_c('div',{staticClass:"Chart__Header"},[_c('div',{staticClass:"Chart__Header__Icon"},[_c('SvgIcon',{attrs:{"icon":"align-left-solid"}})],1),_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('GChart',{attrs:{"type":"AreaChart","data":_vm.chartData,"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }